import React, { FC } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

import Barn from '../components/barn/barn';
import Biler from '../components/bil/biler';
import Boligverdi from '../components/boligverdi/boligverdi';
import Gjeld from '../components/gjeld/gjeld';
import Inntekt from '../components/inntekt/inntekt';
import Leieinntekter from '../components/inntekt/leieinntekter';
import Kontaktinformasjon from '../components/kontaktinformasjon/kontaktinformasjon';
import Laanebeloep from '../components/laan/laanebeloep';
import OekeBoliglaan from '../components/oekeboliglaan/oekeBoliglaan';
import Kvittering from '../components/oppsummering/kvittering';
import Oppsummering from '../components/oppsummering/oppsummering';
import {
    PAGE_BARN_URL,
    PAGE_BILER_URL,
    PAGE_BOLIGVERDI_URL,
    PAGE_GJELD_URL,
    PAGE_INNTEKT_URL,
    PAGE_KONTAKTINFORMASJON_URL,
    PAGE_KVITTERING_URL,
    PAGE_LAANEBELOP_URL,
    PAGE_LEIEINNTEKT_URL,
    PAGE_OPPSUMMERING_URL,
    PAGE_ROOT,
    PAGE_SAMTYKKE_URL,
    PAGE_VEDLEGG_URL,
} from '../components/page/pageUrl';
import Samtykke from '../components/samtykke/samtykke';
import Vedlegg from '../components/vedlegg/vedlegg';
import { SoeknadstypeWeb } from '../generated-types';
import ScrollToTop from '../util/scrollToTop';
import AppContexComp from './appContextContainer';

const soeknadstype = SoeknadstypeWeb.REFINANSIERE_BOLIGLAAN;
const appNameSpace = 'kreditt.boliglaansoeknad.oekeboliglaan-view';

const OekeBoliglaanRouting: FC = () => (
    <AppContexComp appName={appNameSpace} soeknadtype={soeknadstype}>
        <HashRouter>
            <ScrollToTop />
            <Routes>
                <Route path={PAGE_ROOT} element={<OekeBoliglaan navigateTo={PAGE_BOLIGVERDI_URL} />} />
                <Route
                    path={PAGE_BOLIGVERDI_URL}
                    element={
                        <Boligverdi
                            navigateTo={PAGE_LAANEBELOP_URL}
                            navigateToOption={PAGE_KONTAKTINFORMASJON_URL}
                            navigateFrom={PAGE_ROOT}
                        />
                    }
                />
                <Route
                    path={PAGE_LAANEBELOP_URL}
                    element={
                        <Laanebeloep navigateTo={PAGE_KONTAKTINFORMASJON_URL} navigateFrom={PAGE_BOLIGVERDI_URL} />
                    }
                />
                <Route
                    path={PAGE_KONTAKTINFORMASJON_URL}
                    element={
                        <Kontaktinformasjon
                            navigateTo={PAGE_SAMTYKKE_URL}
                            navigateFrom={PAGE_LAANEBELOP_URL}
                            navigateFromOption={PAGE_BOLIGVERDI_URL}
                        />
                    }
                />
                <Route
                    path={PAGE_SAMTYKKE_URL}
                    element={<Samtykke navigateTo={PAGE_INNTEKT_URL} navigateFrom={PAGE_KONTAKTINFORMASJON_URL} />}
                />
                <Route
                    path={PAGE_INNTEKT_URL}
                    element={<Inntekt navigateTo={PAGE_LEIEINNTEKT_URL} navigateFrom={PAGE_SAMTYKKE_URL} />}
                />
                <Route
                    path={PAGE_LEIEINNTEKT_URL}
                    element={<Leieinntekter navigateTo={PAGE_BILER_URL} navigateFrom={PAGE_INNTEKT_URL} />}
                />
                <Route
                    path={PAGE_BILER_URL}
                    element={<Biler navigateTo={PAGE_BARN_URL} navigateFrom={PAGE_LEIEINNTEKT_URL} />}
                />
                <Route
                    path={PAGE_BARN_URL}
                    element={<Barn navigateTo={PAGE_GJELD_URL} navigateFrom={PAGE_BILER_URL} />}
                />
                <Route
                    path={PAGE_GJELD_URL}
                    element={<Gjeld navigateTo={PAGE_VEDLEGG_URL} navigateFrom={PAGE_BARN_URL} />}
                />
                <Route
                    path={PAGE_VEDLEGG_URL}
                    element={<Vedlegg navigateTo={PAGE_OPPSUMMERING_URL} navigateFrom={PAGE_GJELD_URL} />}
                />
                <Route
                    path={PAGE_OPPSUMMERING_URL}
                    element={<Oppsummering navigateTo={PAGE_KVITTERING_URL} navigateFrom={PAGE_VEDLEGG_URL} />}
                />
                <Route path={`${PAGE_KVITTERING_URL}/:soeknadId`} element={<Kvittering />} />
            </Routes>
        </HashRouter>
    </AppContexComp>
);

export default OekeBoliglaanRouting;
